import objectPath from 'object-path'
import { TOTAL_PIE_FORMATTER_KEY } from './config'

export const getTitle = (val) => {
  return val
}

export const getValue = (val, { globals, config }, properties) => {
  let valueType = properties?.total?.valueType
  if (valueType === `Percent`) {
    let index = globals.series.findIndex((value) => value == val)
    let percent = index > -1 ? globals.seriesPercent[index][0] : 100
    return percent.toFixed(1) + `%`
  }
  return val
}

export const getTitleWithValue = ({ globals, config }, properties) => {
  let valueType = properties?.total.valueType
  if (valueType === `Percent`) {
    return `100%`
  }
  let total = globals.seriesTotals.reduce((a, b) => {
    return a + b
  }, 0)
  return total
}

export const getTotal = (chartKey, properties) => {
  let total = ['donut', 'pie']
  if (total.includes(chartKey)) {
    return [
      {
        formatterKey: `${TOTAL_PIE_FORMATTER_KEY}.name`,
        formatter: (val) => getTitle(val),
      },
      {
        formatterKey: `${TOTAL_PIE_FORMATTER_KEY}.value`,
        formatter: (val, opts) => getValue(val, opts, properties),
      },
      {
        formatterKey: `${TOTAL_PIE_FORMATTER_KEY}.total`,
        formatter: (opts) => getTitleWithValue(opts, properties),
      },
    ]
  }
  return null
}
